import { render, staticRenderFns } from "./phone_home.vue?vue&type=template&id=d1e675d2&scoped=true"
import script from "./phone_home.vue?vue&type=script&lang=js"
export * from "./phone_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e675d2",
  null
  
)

export default component.exports